import { render, staticRenderFns } from "./idCardTime.vue?vue&type=template&id=70b3ac05&scoped=true&"
import script from "./idCardTime.vue?vue&type=script&lang=js&"
export * from "./idCardTime.vue?vue&type=script&lang=js&"
import style0 from "./idCardTime.vue?vue&type=style&index=0&id=70b3ac05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3ac05",
  null
  
)

export default component.exports